<template lang="pug">
div
  el-card.card-container(shadow="hover")
    filtro-pvtn(
      @pesquisar="pesquisar",
      @limpar="limpar",
      :filtro="filtro",
      placeholder="Informe o ano"
    )
  el-card.card-container(shadow="hover")
    div#tableHeader
      h3(style="marginTop: 1%; marginLeft : 1%") UPF por ano
      el-button#addPvtnButton(
        type="primary",
        round size="medium",
        @click="inserirEditarUpf()"
        ) Adicionar UPF +
    el-collapse(accordion)
      el-collapse-item(v-for="(dado, index) in dados", :title="dado.ano.slice(0,4)", :key="index")
        table-generica(
          :colunas="colunas",
          :botoesAcao="botoesAcao",
          :dados="dado.upfs"
        )
  app-modal(
    v-if="showModal",
    titulo="Adicionar UPF"
    @closeModal="closeModal"
  )
    template(slot="body")
      div.modalBody
        el-col(:span="8")
          app-label(label="Ano:")
          el-input.input(
            v-model="novaUpf.ano"
            v-mask="['####']",
          )

        el-col(:span="8")
          app-label(label="Mês:")
          el-select(
            v-model="novaUpf.mes"
          )
            el-option(
              v-for='(mes, index) in mesesLista'
              :key="index",
              :label="mes",
              :value="mes"
            )
        el-col(:span="8")
          app-label(label="UPF:")
          app-double-input(
            :precision="4"
            :maxlength="8"
            v-model="novaUpf.valor"

          )
    template(slot="footer")
      div.flex
        el-button(
          :disabled="false"
          @click="closeModal"
        ) Cancelar
        el-button(
          type="primary"
          :disabled="false"
          @click="salvar"
        ) Salvar
</template>

<script>
import { mapActions } from 'vuex'
import FiltroPvtn from '@/screens/analise/vtn/FiltroPvtn'
import TableGenerica from '@/components/TableGenerica'
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import Util from '@/utils/utils'
import meses from './constants/meses'

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    FiltroPvtn,
    TableGenerica,
    AppModal,
    AppLabel,
    AppDoubleInput
  },

  data () {
    return {
      filtro: { },
      colunas: [
        {
          prop: 'vigencia',
          label: 'Mês',
          width: 'auto',
          formatter: this.formatMesVigencia
        },
        {
          prop: 'valor',
          label: 'Ajuste Monetário (UPF/AP)',
          width: 'auto',
          formatter: Util.formatEmptyRow
        }
      ],
      dados: [{
        ano: '',
        upfs: []
      }],
      showModal: false,
      novaUpf: {
        ano: this.anoAtual(),
        mes: this.mesAtual(),
        valor: 0
      },
      isEdicao: false
    }
  },

  computed: {
    mesesLista () {
      return meses.mesesLista
    }
  },

  async mounted () {
    this.getUpfs()
  },

  methods: {
    ...mapActions({
      createUpf: 'vtn/createUpf',
      updateUpf: 'vtn/updateUpf',
      deleteUpf: 'vtn/deleteUpf',
      getAllUpfGroupByYear: 'vtn/getAllUpfGroupByYear'
    }),

    botoesAcao (upf) {
      return [
        {
          click: this.inserirEditarUpf.bind(this, upf),
          icon: 'edit',
          title: 'Inserir/Editar',
          active: true
        },
        {
          click: this.excluirUpf.bind(this, upf),
          icon: 'delete',
          title: 'Excluir',
          active: true
        }
      ]
    },

    pesquisar () {
      // TODO chamar rota do back passando o filtro
    },

    limpar () {
      this.filtro = {}
      this.getUpfs()
    },

    async salvar () {
      if (this.isEdicao) {
        await this.updateUpf(this.novaUpf)
      } else {
        await this.createUpf(this.novaUpf)
      }
      this.dados = await this.getAllUpfGroupByYear()
      this.closeModal()
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        this.$messages.DADOS_SALVOS_SUCESSO
      )

      this.isEdicao = false
    },

    inserirEditarUpf (upf) {
      if (upf) {
        this.isEdicao = true
        this.novaUpf = {
          id: upf.id,
          mes: this.formatMesVigencia(0, 0, upf.vigencia),
          ano: upf.vigencia.slice(0, 4),
          valor: upf.valor
        }
      }
      this.showModal = true
    },

    async excluirUpf (upf) {
      await this.deleteUpf(upf.id)
      await this.getUpfs()
    },

    closeModal () {
      this.showModal = false
      this.isEdicao = false
    },

    formatMesVigencia (row, column, prop) {
      return meses.mesesObject[prop.slice(5, 7)]
    },

    anoAtual () {
      return new Date().getFullYear()
    },

    mesAtual () {
      const mes = new Date().getMonth()
      return meses.mesesLista[mes]
    },

    async getUpfs () {
      this.dados = await this.getAllUpfGroupByYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

#tableHeader {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1%;
}

#addPvtnButton {
  height: min-content;
}

.flex {
  display: flex;
  justify-content: space-between;
}

.modalBody {
  width: 100%;
  display: flex;
  gap: 3%;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/ConfigurarUpf.vue